<template>
  <v-container fluid>
    <v-expansion-panels popout accordion v-model="openPanels" tile class="narrow-expansion-panels">
      <v-expansion-panel v-for="(accountAdvance, index) in filteredAdvances" :key="index"
        @click="panelClicked(accountAdvance)">
        <v-expansion-panel-header class="subtitle-1 py-6">
          <v-row>
            <v-col>
              <span> {{ accountAdvance.accountName }} </span>
            </v-col>

            <v-col cols="auto">
              <span> {{ formatMoney(accountAdvance.balance) }} </span>
            </v-col>
          </v-row>

          <template #actions>
            <v-icon class="ml-2">mdi-chevron-down</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <AdvancePanelContent :dense="dense" :accountAdvance="accountAdvance" :asAtDate="asAtDate"
            @refresh="$emit('refresh')" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { formatMoney } from '@/utils/NumericMutations.js'
import { mapGetters } from 'vuex'
import { localeCompareAlphanumeric } from '@/utils/base'

export default {
  name: 'AccountAdvancePanels',

  components: {
    AdvancePanelContent: () => import('./AdvancePanelContent.vue')
  },

  props: {
    search: String,
    advances: Array,
    dense: Boolean,
    asAtDate: String
  },

  computed: {
    ...mapGetters('advances', ['allAdvances']),
    filteredAdvances () {
      if (this.search) {
        return this.accountAdvances.filter((v) => {
          return v.accountName.toLowerCase().includes(this.search.toLowerCase()) || v.balance.toString().includes(this.search.toLowerCase())
        })
      } else {
        return this.accountAdvances
      }
    }
  },

  watch: {
    advances: {
      handler () {
        this.accountAdvances = []
        this.createAccountAdvances()
      },
      deep: true
    },
    filteredAdvances: {
      handler () {
        let total = 0
        if (!this.filteredAdvances) {
          this.$emit('advancesTotalUpdated', total)
        } else {
          total = this.filteredAdvances.reduce((acc, v) => acc + v.balance, 0)
          this.openPanels = this.filteredAdvances.length === 1
            ? 0
            : this.accountAdvances.findIndex(a => a.accountId === this.openPanelAccountId)
          this.$emit('advancesTotalUpdated', total)
        }
      },
      deep: true
    }
  },

  data: () => ({
    accountAdvances: [],
    accounts: [],
    openPanels: [],
    openPanelAccountId: null
  }),

  created () {
    this.openPanels = this.filteredAdvances.length === 1 ? 0 : null
  },

  methods: {
    formatMoney,
    createAccountAdvances () {
      if (this.advances) {
        this.advances.forEach(advance => {
          const accountIndex = this.accountAdvances.findIndex(v => v.accountId === advance.payeeId)

          if (accountIndex > -1) {
            this.updateAccountAdvance(advance, accountIndex)
          } else {
            this.createAccountAdvance(advance)
          }
        })
      }
      this.accountAdvances.sort((accountA, accountB) => localeCompareAlphanumeric(accountA.accountName, accountB.accountName))
    },

    updateAccountAdvance (advance, index) {
      const accountAdvance = this.accountAdvances[index]
      accountAdvance.amount += advance.amount
      accountAdvance.balance += advance.balance
      accountAdvance.advances.push(advance)

      this.accountAdvances[index] = accountAdvance
    },

    createAccountAdvance (advance) {
      this.accountAdvances.push({
        accountId: advance.payeeId,
        accountName: advance.payeeName,
        advances: [advance],
        amount: advance.amount,
        balance: advance.balance
      })
    },

    panelClicked (account) {
      this.openPanelAccountId = account.accountId
    }
  }

}
</script>
